import Api from "../apiService";

class conversationsApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/conversations`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, conversationId) {
    return Api.getRequest(
      `companies/${companyId}/conversations/${conversationId}`,
      {},
      Api.authHeaders()
    );
  }

  markRead(companyId, conversationId) {
    return Api.patchRequest(
      `companies/${companyId}/conversations/${conversationId}/mark_read`,
      {},
      Api.authHeaders()
    );
  }
}

export default new conversationsApi();
